// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tr.rai-orlid td{height:40px;padding-left:0}tr.rai-orlid td.tdicon{width:40px;padding-left:12px;padding-right:6px;padding-top:0;padding-bottom:0}tr.rai-orlid td.tdicon svg{margin:auto}tr.rai-orlid .w-ch-10{width:10ch}tr.rai-orlid--closed{background-color:var(--v-ui-lighten5);color:rgba(0,0,0,.6)}", ""]);
// Exports
module.exports = exports;
